import { render } from "./payback.vue?vue&type=template&id=0d3cb64f&scoped=true"
import script from "./payback.vue?vue&type=script&lang=js"
export * from "./payback.vue?vue&type=script&lang=js"

import "./payback.vue?vue&type=style&index=0&id=0d3cb64f&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3cb64f"]])

export default __exports__